import { useTranslation } from 'react-i18next';

import {
  type AppLocale,
  DEFAULT_LOCALE,
  isAppLocale,
  LOCALE_LABELS,
  SUPPORTED_LOCALES,
} from './config.js';

export interface UseLanguageResult {
  language: AppLocale;
  setLanguage: (locale: AppLocale) => void;
  locales: readonly AppLocale[];
  labels: Record<AppLocale, string>;
}

export function useLanguage(): UseLanguageResult {
  const { i18n } = useTranslation();

  const language = isAppLocale(i18n.language) ? i18n.language : DEFAULT_LOCALE;

  const setLanguage = (locale: AppLocale): void => {
    void i18n.changeLanguage(locale);
  };

  return {
    language,
    setLanguage,
    locales: SUPPORTED_LOCALES,
    labels: LOCALE_LABELS,
  };
}
